import { useStores } from "../../../../../stores/useStores";
import LoginButtons from "./LoginButtons";
import classNames from "classnames";
import { useGridType } from "../../../../../hooks/useGridType";
import { GridTypes } from "../../../../../utils/SchoolBlocksUtilities";
import styles from "./styles/PrivateLogin.module.scss";

export default function PrivateLogin() {
  const { userStore } = useStores();
  const gridType = useGridType();

  const containerClassName = classNames({
    ["sb-content-width"]: true,
    [styles.container]: true,
    [styles.containerTerrace]: gridType === GridTypes.terraced,
  });

  return (
    <div className={containerClassName}>
      <div className="sb-error-block">
        <div className="sb-error-message">
          <h3 className={`text-danger ${styles.warning}`}>
            {userStore.id
              ? "This is a private page that you do not have permission to view."
              : "This page is private, please log in if you have viewing permissions."}
          </h3>
          {!!userStore.id || (
            <div style={{ marginTop: "1rem" }}>
              <LoginButtons />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
